import { lazy } from "react";

const loadMapModule = () => import("@trotroways/ui/map");

export const Map = lazy(async () => ({
  default: (await loadMapModule()).Map,
}));
export const MapMarker = lazy(async () => ({
  default: (await loadMapModule()).MapMarker,
}));
export const MapRoute = lazy(async () => ({
  default: (await loadMapModule()).MapRoute,
}));
export const MarkerContent = lazy(async () => ({
  default: (await loadMapModule()).MarkerContent,
}));
